import React, { FC, useCallback, useMemo, useState } from 'react';
import { Form, Input, Button, notification, Tooltip } from 'src/common';
import styles from '../index.module.scss';
import { useForm } from 'antd/lib/form/Form';
import { useTranslation } from 'react-i18next';
import {
  useUpdateCustomBidField,
  clearTendersCacheAfterUpdateCustomBidFields
} from 'src/models/company/CustomBidFields/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  id: string;
  name: string | null;
  onClose: () => void;
}

interface IForm {
  name?: string;
}

export const EditView: FC<IProps> = props => {
  const { id, name, onClose } = props;
  const [form] = useForm<IForm>();
  const { t } = useTranslation();

  const initialValues = useMemo(() => {
    return {
      name
    };
  }, [name]);

  const [updateCustomBidField, { loading }] = useUpdateCustomBidField();

  const onUpdate = useCallback(() => {
    form.validateFields().then(values => {
      updateCustomBidField({
        variables: {
          id,
          name: values.name
        },
        update: cache => clearTendersCacheAfterUpdateCustomBidFields(cache)
      })
        .then(() => {
          onClose();
        })
        .catch(() => {
          notification.error({
            description: t('Common.unknownErrorDesc'),
            message: t('Common.unknownError')
          });
        });
    });
  }, [form, id, onClose, t, updateCustomBidField]);

  const [isDisabled, setIsDisabled] = useState(!name);

  const onValuesChange = useCallback(
    (changedValues: Partial<IForm>, values: IForm) => {
      setIsDisabled(!values.name);
    },
    [setIsDisabled]
  );

  return (
    <div>
      <Form form={form} initialValues={initialValues} className={styles.form} onValuesChange={onValuesChange}>
        <div className={styles.item}>
          <Form.Item name={'name'} rules={[{ max: 35, message: t('Common.inputTooLong', { inputName: 'Name' }) }]}>
            <Input placeholder={'Name'} />
          </Form.Item>
        </div>
      </Form>
      <div className={styles.footer}>
        <Button type={'primary'} onClick={onUpdate} loading={loading} disabled={isDisabled}>
          {t('Common.save')}
        </Button>
        <Tooltip title={t('Common.cancel')}>
          <Button type={'text'} icon={<FontAwesomeIcon icon={faTimes} />} onClick={onClose} />
        </Tooltip>
      </div>
    </div>
  );
};

export default EditView;
